var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 21 21",
    fill: "none",
    className: "injected-svg",
    "data-src": "/icons/new/menu-mixer.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 0a3.501 3.501 0 0 0-3.409 2.706H.955a.955.955 0 1 0 0 1.909h9.917a3.502 3.502 0 0 0 6.638 0h2.535a.955.955 0 0 0 0-1.91H17.6A3.501 3.501 0 0 0 14.19 0ZM5.282 7a3.502 3.502 0 0 0-3.374 2.567l-.978.025a.955.955 0 1 0 .05 1.909l.94-.025a3.502 3.502 0 0 0 6.716.025h11.41a.955.955 0 0 0 0-1.909H8.663A3.502 3.502 0 0 0 5.282 7ZM14.19 14a3.502 3.502 0 0 0-3.348 2.479H.955a.954.954 0 1 0 0 1.909h9.85a3.502 3.502 0 0 0 6.772 0h2.468a.955.955 0 0 0 0-1.91H17.54A3.502 3.502 0 0 0 14.192 14Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood);
export default __webpack_public_path__ + "static/media/mood.1df77bb101b0094ee6db68691c464bb4.svg";
export { ForwardRef as ReactComponent };